function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Emblem } from 'app/components/icons';
import { COLORS, Image, SIZES, TextBadge } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const EmblemContainer = styled.div.withConfig({
  componentId: "sc-4u3f88-0"
})(["position:relative;width:", ";height:", ";"], SIZES['32'], SIZES['32']);
const SCTextBadge = styled(TextBadge).withConfig({
  componentId: "sc-4u3f88-1"
})(["&&&{right:0;width:", ";height:", ";font-size:", ";}"], SIZES['10'], SIZES['10'], SIZES['8']);
export default function MatchRowTeaserTeamImage(_ref) {
  let {
    team
  } = _ref;
  const level = team.formatLevel();
  const imageData = team.getImageData();
  const emblem = imageData ? /*#__PURE__*/React.createElement(Image, _extends({}, imageData, {
    width: 32,
    height: 32
  })) : /*#__PURE__*/React.createElement(Emblem, {
    style: {
      color: COLORS.lightGrey,
      fontSize: 32
    }
  });
  return /*#__PURE__*/React.createElement(EmblemContainer, {
    "data-sentry-element": "EmblemContainer",
    "data-sentry-component": "MatchRowTeaserTeamImage",
    "data-sentry-source-file": "MatchRowTeaserTeamImage.tsx"
  }, level ? /*#__PURE__*/React.createElement(SCTextBadge, {
    value: level,
    position: 1
  }) : null, emblem);
}